import React, { forwardRef } from 'react'
import { UserMenu as RaUserMenu } from 'react-admin'
import MenuItem from '@material-ui/core/MenuItem'
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import { useDemoMode } from '../hooks/useDemoMode'

const DemoModeToggle = forwardRef((props, ref) => {
  const { isDemoMode, toggleDemoMode } = useDemoMode()

  const handleToggle = () => {
    toggleDemoMode()
    // Refresh the page after a short delay to apply changes
    setTimeout(() => {
      window.location.reload()
    }, 100)
  }

  return (
    <MenuItem
      onClick={handleToggle}
      ref={ref}
    >
      {isDemoMode ? (
        <>
          <VisibilityOffIcon /> <span style={{ paddingLeft: 10 }}>Disable Demo Mode</span>
        </>
      ) : (
        <>
          <VisibilityIcon /> <span style={{ paddingLeft: 10 }}>Enable Demo Mode</span>
        </>
      )}
    </MenuItem>
  )
})

const UserMenu = (props) => {
  return (
    <RaUserMenu {...props}>
      <DemoModeToggle />
    </RaUserMenu>
  )
}

export default UserMenu

